<template>
  <div>
    <ly-tab v-model="selectedId" :items="items" :options="options" @change="change"></ly-tab>
    <div class="title">赔率：{{this.data[0].data[selectedId].odds }}</div>
    <ul>
      <li
        :class="['num'+i]"
        v-for="i in count"
        :key="'kk'+i"
        @click="selected(i)"
        :style="{backgroundColor:(selectedCount[i]? '#e32116':''),
            color:(selectedCount[i]? '#fff':'')
        }"
      >{{i}}
      </li>
    </ul>
  </div>
</template>
<script>
  import Vue from "../../../../../utils/bus"

  export default {
    name: "tab-swiper",
    props: {
      data: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    data() {
      return {
        rate: 1,
        selectedId: 0,
        selectedCount: new Array(21 - 1).fill(false),
        options: {
          activeColor: "#1d98bd"
          // 可在这里指定labelKey为你数据里文字对应的字段
        }
      };
    },
    methods: {
      selected(i) {
        this.selectedCount[i] = !this.selectedCount[i];
        this.selectedCount.push(false);
        this.selectedCount.pop();
        let selectedCount = this.selectedCount;
        let selectedId = this.selectedId;
        this.$emit("selectedlm", {selectedCount, selectedId});
      },
      change(item, index) {
        let selectedCount = this.selectedCount;
        let selectedId = index;
        this.$emit("selectedlm", {selectedCount, selectedId});
        this.$emit("selectedlm", {selectedCount, selectedId});
      }
    },
    created() {
      Vue.$on("reseTabSwiper", () => {
        this.selectedCount = [];
      })
    },
    computed: {
      count() {
        return new Array(21 - 1).fill(1).map((el, i) => 1 + i);
      },

      items() {
        let tt = this.data[0].data.map(item => {
          return {label: item.class3};
        });
        return tt;
      }
    }
  };
</script>
<style lang="less" scoped>
  .title {
    font-size: 3vw;
    margin: 20px;
  }

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    li {
      background-color: #fff;
      width: 76px;
      height: 76px;
      margin-top: 20px;
      margin-left: 20px;

      display: flex;
      font-size: 3vw;
      box-sizing: border-box;
      box-shadow: 0 1px 2px 1px #ccc;
      font-weight: bold;
      align-items: center;
      border-radius: 76px;
      justify-content: center;

      &.num1 {
        border: 2px solid #ffff00;
      }

      &.num2 {
        border: 2px solid #0089ff;
      }

      &.num3 {
        border: 2px solid #4d4d4d;
      }

      &.num4 {
        border: 2px solid #ff7300;
      }

      &.num5 {
        border: 2px solid #81ffff;
      }

      &.num6 {
        border: 2px solid #5200ff;
      }

      &.num7 {
        border: 2px solid #b8b8b8;
      }

      &.num8 {
        border: 2px solid #ff0000;
      }

      &.num9 {
        border: 2px solid #530000;
      }

      &.num10 {
        border: 2px solid #1c8800;
      }
    }

  }

  /*
  .lmnum3{
    li{
              border:0px;
          width: 52px;
          height: 52px;
          margin-top: 22px;
          margin-left: 18px;
          display: inline-block;
          background-size: 100%;
          background-position-x: 0;
          background-repeat: no-repeat;
          &.num1{ background-image:url("/static/images/nc/1.png") }
          &.num2{ background-image:url("/static/images/nc/2.png")}
          &.num3{ background-image:url("/static/images/nc/3.png") }
          &.num4{ background-image:url("/static/images/nc/4.png") }
          &.num5{ background-image:url("/static/images/nc/5.png") }
          &.num6{ background-image:url("/static/images/nc/6.png")}
          &.num7{ background-image:url("/static/images/nc/7.png")}
          &.num8{ background-image:url("/static/images/nc/8.png") }
          &.num9{ background-image:url("/static/images/nc/9.png") }
          &.num10{ background-image:url("/static/images/nc/10.png") }
          &.num11{ background-image:url("/static/images/nc/11.png") }
          &.num12{ background-image:url("/static/images/nc/12.png")}
          &.num13{ background-image:url("/static/images/nc/13.png") }
          &.num14{ background-image:url("/static/images/nc/14.png") }
          &.num15{ background-image:url("/static/images/nc/15.png") }
          &.num16{ background-image:url("/static/images/nc/16.png") }
          &.num17{ background-image:url("/static/images/nc/17.png") }
          &.num18{ background-image:url("/static/images/nc/18.png") }
          &.num19{ background-image:url("/static/images/nc/19.png") }
          &.num20{ background-image:url("/static/images/nc/20.png") }
      }
    }
  .lmnum1, .lmnum17{
    li{
              border:0px;
          width: 52px;
          height: 52px;
          margin-top: 22px;
          margin-left: 18px;
          display: inline-block;
          background-size: 100%;
          background-position-x: 0;
          background-repeat: no-repeat;
          &.num1{ background-image:url("/static/images/ss/1.png")}
          &.num2{ background-image:url("/static/images/ss/2.png")}
          &.num3{ background-image:url("/static/images/ss/3.png") }
          &.num4{ background-image:url("/static/images/ss/4.png") }
          &.num5{ background-image:url("/static/images/ss/5.png") }
          &.num6{ background-image:url("/static/images/ss/6.png") }
          &.num7{ background-image:url("/static/images/ss/7.png") }
          &.num8{ background-image:url("/static/images/ss/8.png") }
          &.num9{ background-image:url("/static/images/ss/9.png") }
          &.num10{ background-image:url("/static/images/ss/10.png") }
          &.num11{ background-image:url("/static/images/ss/11.png") }
          &.num12{ background-image:url("/static/images/ss/12.png") }
          &.num13{ background-image:url("/static/images/ss/13.png") }
          &.num14{ background-image:url("/static/images/ss/14.png") }
          &.num15{ background-image:url("/static/images/ss/15.png") }
          &.num16{ background-image:url("/static/images/ss/16.png") }
          &.num17{ background-image:url("/static/images/ss/17.png") }
          &.num18{ background-image:url("/static/images/ss/18.png") }
          &.num19{ background-image:url("/static/images/ss/19.png") }
          &.num20{ background-image:url("/static/images/ss/20.png") }
      }
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/components/tab-swiper/index.vue